<template>
	<button
		:class="['custom-btn', `btn-${type}`]"
		:style="buttonStyle"
		:disabled="disabled"
		@click="handleClick"
	>
		<span class="btn-title">{{ title }}</span>
		<span v-if="subtitle" class="btn-subtitle">{{ subtitle }}</span>
	</button>
</template>

<script>
export default {
	name: 'BottomButton',
	props: {
		title: {
			type: String,
			required: true
		},
		subtitle: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'secondary'].includes(value)
		},
		disabled: {
			type: Boolean,
			default: false
		},
		width: {
			type: String,
			default: ''
		}
	},
	computed: {
		buttonStyle() {
			const style = {};
			if (this.width) {
				style.width = this.width;
				style.flex = '0 1 auto';
				style.minWidth = '0';
			}
			return style;
		}
	},
	methods: {
		handleClick(event) {
			if (!this.disabled) {
				this.$emit('click', event);
			}
		}
	}
}
</script>

<style scoped>
.custom-btn {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	height: 49px;
	padding: 10px 20px;
	border: none;
	border-radius: 6px;

	font-size: 16px;
	cursor: pointer;
	transition: all 0.3s ease;
	gap: 2px;
}

.btn-primary {
	background: #4A9FFF;
	color: white;
	border: 1px solid #4A9FFF;
}

.btn-primary:hover:not(:disabled) {
	background: #3D8FEF;
}

.btn-secondary {
	background: white;
	color: #4A9FFF;
	border: 1px solid #4A9FFF;
}

.btn-secondary:hover:not(:disabled) {
	background: #F0F7FF;
}

.btn-title {
	font-size: 16px;
	font-weight: 600;
	line-height: 22px;
}

.btn-subtitle {
	margin-top: -2px;
	font-size: 12px;
	line-height: 17px;
}

.custom-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// BottomButton.vue?6d4f10f9